import { Component, Input } from '@angular/core';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
  selector: 'app-gamification-daily-tips',
  imports: [NgIf, NgSwitch, NgSwitchCase],
  templateUrl: './gamification-daily-tips.component.html',
  standalone: true
})
export class GamificationDailyTipsComponent {
  @Input() dayIndex: number = 0;
  @Input() username: string = '';
  @Input() selectedDayTip: string | null = null;
}
